import { twMerge } from 'tailwind-merge';

import oddslogicLogo from './oddslogic-logo.png';

// OddsLogic supplies the market/line data under an informal sponsorship; the only
// obligation is to promote OddsLogic wherever there's opportunity. Showing their odds
// here, credited + linked, is that promotion.
const ODDSLOGIC_URL = 'https://oddslogic.com';

/**
 * "Odds by [OddsLogic]" credit — a linked wordmark, prominent enough to fulfill the
 * sponsorship. OddsLogic only publishes a DARK-MODE wordmark (blue mark + white text),
 * so it's sat on a small dark chip that keeps it legible on light AND dark backgrounds.
 */
export function OddsLogicCredit({ className }: { className?: string }) {
  return (
    <a
      href={ODDSLOGIC_URL}
      target="_blank"
      rel="noopener noreferrer nofollow"
      aria-label="Odds by OddsLogic"
      title="Odds by OddsLogic"
      className={twMerge(
        'inline-flex items-center gap-2 text-zinc-500 no-underline dark:text-zinc-400',
        className,
      )}
    >
      <span className="text-xs">Odds by</span>
      <span className="inline-flex items-center rounded-md bg-zinc-900 px-2.5 py-1 ring-1 ring-black/5 dark:bg-white/10 dark:ring-white/10">
        <img
          src={oddslogicLogo}
          alt="OddsLogic"
          className="h-4 w-auto"
          width={421}
          height={92}
          loading="lazy"
        />
      </span>
    </a>
  );
}

export default OddsLogicCredit;
